import dagre from 'dagre';

const NODE_WIDTH = 180;
const NODE_HEIGHT = 90;

export function getLayoutedElements(nodes, edges, direction = 'TB') {

  const dagreGraph = new dagre.graphlib.Graph();
  dagreGraph.setDefaultEdgeLabel(() => ({}));
  
  dagreGraph.setGraph({ rankdir: direction });

  nodes.forEach((node) => {
    dagreGraph.setNode(node.id, {
      width: NODE_WIDTH,
      height: NODE_HEIGHT,
    });
  });

  edges.forEach((edge) => {
    dagreGraph.setEdge(edge.source, edge.target);
  });

  dagre.layout(dagreGraph);

  const layoutedNodes = nodes.map((node) => {
    const nodePosition = dagreGraph.node(node.id);

    return {
      ...node,
      position: {
        x: nodePosition.x - NODE_WIDTH / 2,
        y: nodePosition.y - NODE_HEIGHT / 2,
      },
      sourcePosition: direction === 'TB' ? 'bottom' : 'right',
      targetPosition: direction === 'TB' ? 'top' : 'left',
    };
  });

  return { nodes: layoutedNodes, edges };
}
